import React from 'react';
import { getTheme, IStyle, ITheme, mergeStyleSets } from '@fluentui/react';
import { ITimingSpecComponentModel } from '../../parser/timing-spec';
import { MarkdownTimedSection } from '../timing-section';
import { xlate } from '../../../../framework/utils/i18n';
import { getComponentId } from '../../parser/core';
import { BwjButton, BwjButtonType } from '../../../../framework/components/bwj-button';

interface IMarkdownViewportProps {
  componentModel: ITimingSpecComponentModel[];
  baseFontSize: number;
  onSectionHeadingClick?: (component: ITimingSpecComponentModel) => void;
  onToggleSectionNotes?: (component: ITimingSpecComponentModel) => void;
  onEndDiscussion?: () => void;
}

const getViewportClasses = (theme: ITheme, baseFontSize: number) => {
  const root: IStyle = {
    backgroundColor: theme.palette.neutralLight,
    fontSize: baseFontSize,

    '& b': {
      textDecoration: 'underline',
      fontWeight: 'normal',
    }
  };
  
  const contentBody: IStyle = {
    padding: '2em',
    paddingBottom: 96,
    fontSize: '1em',
  };
  
  const endDiscussionTray: IStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
    marginBottom: '2em',
  };

  return mergeStyleSets({
    root,
    contentBody,
    endDiscussionTray,
  });
}

export const MarkdownViewport: React.FunctionComponent<IMarkdownViewportProps> = (props) => {
  const theme = getTheme();
  const classes = getViewportClasses(theme, props.baseFontSize);

  return (
    <div className={classes.root}>
      <div className={classes.contentBody}>
        {props.componentModel.map(section =>
        <MarkdownTimedSection
          key={getComponentId(section)}
          componentModel={section}
          onClick={props.onSectionHeadingClick}
          onToggleNotesSection={props.onToggleSectionNotes}
          warningIconDescription={xlate('Section at risk of going overtime')}
          firmTimingTitle={xlate('The timing of this section is firm')}
          flexTimingTitle={xlate('The timing of this section is flexible')}
          shareTimingTitle={xlate('The timing of this section is a proportional share of the time remaining')}
          computedTimeShareDurationDescription={xlate('Share of remaining time and approximate section duration')}
          uncomputedTimeShareDurationDescription={xlate('Share of remaining time')}
          flexTimeDurationDescription={xlate('Approximate section duration')}
          firmTimeDurationDescription={xlate('Section duration')}
        />)}
        <div className={classes.endDiscussionTray}>
          {!!props.onEndDiscussion &&
          <BwjButton
            buttonStyle={BwjButtonType.PrimaryStandard}
            text={xlate('End discussion')}
            onClick={props.onEndDiscussion}
            styles={{ root: { minWidth: '25%', fontSize: 20 }}}
          />}
        </div>
      </div>
    </div>
  );
};
